import React from 'react';
import { Button, Space, Popconfirm, InputNumber } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

const QuantityControl = ({ 
  value, 
  onIncrease, 
  onDecrease, 
  onDirectChange,
  min = 0,
  max,
  size = 'small',
  showDirectInput = false,
  confirmIncrease = false,
  confirmDecrease = false,
  itemName = 'item'
}) => {
  const handleDecrease = () => {
    if (value > min && !confirmDecrease) {
      onDecrease?.();
    }
  };

  const handleIncrease = () => {
    if ((!max || value < max) && !confirmIncrease) {
      onIncrease?.();
    }
  };

  const handleConfirmedDecrease = () => {
    if (value > min) {
      onDecrease?.();
    }
  };

  const handleConfirmedIncrease = () => {
    if (!max || value < max) {
      onIncrease?.();
    }
  };

  const decreaseButton = (
    <Button 
      size={size}
      icon={<MinusOutlined />}
      disabled={value <= min}
      onClick={handleDecrease}
      danger
    />
  );

  const increaseButton = (
    <Button 
      size={size}
      icon={<PlusOutlined />}
      disabled={max && value >= max}
      onClick={handleIncrease}
      type="primary"
      style={{ background: '#52c41a', borderColor: '#52c41a' }}
    />
  );

  return (
    <Space>
      {confirmDecrease ? (
        <Popconfirm
          title="Decrease Quantity"
          description={`Remove 1 ${itemName} from inventory?`}
          onConfirm={handleConfirmedDecrease}
          okText="Yes"
          cancelText="No"
          disabled={value <= min}
        >
          <Button 
            size={size}
            icon={<MinusOutlined />}
            disabled={value <= min}
            danger
          />
        </Popconfirm>
      ) : (
        decreaseButton
      )}

      {showDirectInput ? (
        <InputNumber
          size={size}
          value={value}
          min={min}
          max={max}
          onChange={onDirectChange}
          style={{ width: '60px' }}
        />
      ) : (
        <span style={{ 
          minWidth: '30px', 
          textAlign: 'center', 
          display: 'inline-block',
          fontWeight: 'bold',
          color: 'var(--text-primary)'
        }}>
          {value}
        </span>
      )}

      {confirmIncrease ? (
        <Popconfirm
          title="Increase Quantity"
          description={`Add 1 ${itemName} to inventory?`}
          onConfirm={handleConfirmedIncrease}
          okText="Yes"
          cancelText="No"
          disabled={max && value >= max}
        >
          <Button 
            size={size}
            icon={<PlusOutlined />}
            disabled={max && value >= max}
            type="primary"
            style={{ background: '#52c41a', borderColor: '#52c41a' }}
          />
        </Popconfirm>
      ) : (
        increaseButton
      )}
    </Space>
  );
};

export default QuantityControl;
